import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ISnackMessage {
  name: string;
  complete: boolean;
  message: string;
}

export enum SnackMessageNames {
  META_LOADED = 'META_LOADED',
  RULES_LOADED = 'RULES_LOADED',
  CHAIN_SAVED = 'CHAIN_SAVED',
  RESTORING_CHAINS = 'RESTORING_CHAINS',
  SWAPPING_SCHEDULES = 'SWAPPING_SCHEDULES',
}

export enum SnackMessageText {
  META_LOADED = 'Loading from Bullhorn',
  RULES_LOADED = 'Loading Rules',
  CHAIN_SAVED = 'Saving chain: ',
  RESTORING_CHAINS = 'Restoring ChainGroups',
  SWAPPING_SCHEDULES = 'Swapping schedules'
}

@Injectable({
  providedIn: 'root'
})
export class LoadingSnackbarService {
  private _messages: ISnackMessage[] = [];

  private messagesSubject = new Subject<ISnackMessage[]>();
  public messages$ = this.messagesSubject.asObservable();

  constructor() { }

  show(name: SnackMessageNames, message?: string): void {
    this._messages.push({
      name: name,
      complete: false,
      message: message ? message : SnackMessageText[name]
    });
    this.messagesSubject.next(this._messages);
  }

  hide(name: SnackMessageNames): void {
    let index = this._messages.findIndex(m => m.name === name);
    this._messages[index].complete = true;
    this.messagesSubject.next(this._messages);

    setTimeout(() => {
      index = this._messages.findIndex(m => m.name === name);
        this._messages.splice(index, 1);
    }, 2000);

    this.messagesSubject.next(this._messages);
  }
}
